import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ButtonLink } from '../ButtonLink/ButtonLink';

interface NoAccessToViewProps {
    translations: Record<string, string>;
}

export const NoAccessToView: React.FC<NoAccessToViewProps> = ({ translations }) => (
    <Box textAlign="center" mt={8}>
        <Typography variant="h5" gutterBottom>
            {translations.ERROR_NO_ACCESS_TITLE}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
            {translations.ERROR_NO_ACCESS}
        </Typography>

        <Box mt={8}>
            <ButtonLink to="/" text={translations.GLOBAL_HOME_BUTTON} />
        </Box>
    </Box>
);
